import { useState } from "react";

import Button from "@mui/material/Button";
import Checkbox from "@mui/material/Checkbox";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import FormControlLabel from "@mui/material/FormControlLabel";
import { Box, Typography } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { useTranslation } from "react-i18next";

import highlightOffIcon from "src/assets/svg-icons/high-light-off.svg";

export function CancelPurchaseOrderPopup({
  open,
  handleClose,
  handleConfirm,
  isPending = false,
}: {
  open: boolean;
  handleClose: () => void;
  handleConfirm: () => void;
  isPending?: boolean;
}) {
  const { t } = useTranslation("inventory");
  const { t: generalT } = useTranslation("general");
  const [youNotifiedTheSupplier, setYouNotifiedTheSupplier] = useState(false);

  const handleClosePopup = () => {
    setYouNotifiedTheSupplier(false);
    handleClose();
  };

  const handleConfirmCancel = () => {
    if (!youNotifiedTheSupplier) return;

    handleConfirm();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClosePopup}
      aria-labelledby="cancel-dialog-title"
      maxWidth="xs"
      fullWidth
    >
      <Box p={2} pt={5} textAlign="center">
        <img height={96} src={highlightOffIcon} alt="" />

        <DialogTitle id="cancel-dialog-title">
          <Typography color="textPrimary" fontSize="26px" fontWeight={600}>
            {generalT("cancel")}
          </Typography>
        </DialogTitle>

        <DialogContent>
          {/* <Typography color="textPrimary" fontWeight={500}>
            {t("areYouWantToCancel")}?
          </Typography> */}

          <FormControlLabel
            sx={{ mt: 2 }}
            control={
              <Checkbox
                checked={youNotifiedTheSupplier}
                onChange={(e) => setYouNotifiedTheSupplier(e.target.checked)}
              />
            }
            label={t("youNotifiedTheSupplier")}
          />
        </DialogContent>

        <DialogActions>
          <Button
            fullWidth
            onClick={handleClosePopup}
            variant="outlined"
            color="tertiary"
          >
            {generalT("cancel")}
          </Button>

          <LoadingButton
            fullWidth
            onClick={handleConfirmCancel}
            variant="contained"
            color="error"
            autoFocus
            loading={isPending}
            disabled={!youNotifiedTheSupplier}
          >
            {generalT("confirm")}
          </LoadingButton>
        </DialogActions>
      </Box>
    </Dialog>
  );
}
